import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSidebarContext } from '../../contexts/Sidebar';
import { StyledMenu } from './Sidebar.styles';
const Menu = React.forwardRef(({ children, ...restProps }, ref) => {
    const { broken } = useSidebarContext();
    return (_jsx(StyledMenu, { ref: ref, broken: broken, ...restProps, children: children }));
});
Menu.displayName = 'Menu';
export default Menu;
